/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import DotComponent from '../../../../../ui/DotComponent';
import SolutionOption from '../SolutionOption';
import { SafePureComponent } from '../../../../../../utils/SafePureComponent';
import * as styles from './index.styles';

const defaultData = [
  { Label: { value: 'Office Space' }, RawValue: { value: '/office-space' } },
  {
    Label: { value: 'Virtual Office' },
    RawValue: { value: '/virtual-offices' },
  },
  { Label: { value: 'Coworking' }, RawValue: { value: '/coworking' } },
  { Label: { value: 'Meeting Rooms' }, RawValue: { value: '/meeting-rooms' } },
];

export class SolutionsList extends SafePureComponent {
  fields = defaultsDeep(this.props.fields, defaultData);

  solutionsOptions = () => {
    const { currentQueryString, closeModal } = this.props;

    return this.fields.map((solution, index) => (
      <SolutionOption
        isCurrent={get(solution, 'RawValue.value') === currentQueryString}
        key={`solution-${index}`}
        label={get(solution, 'Label.value')}
        value={get(solution, 'RawValue.value')}
        closeModal={closeModal}
      />
    ));
  };

  safeRender() {
    const { modalHeadline, innerRef } = this.props;

    return (
      <section ref={innerRef} css={styles.solutionsSection}>
        <h2 css={styles.modalHeadline}>
          {modalHeadline}
          <DotComponent />
        </h2>
        {this.props.children}
        <ul css={styles.solutionsList}>{this.solutionsOptions()}</ul>
      </section>
    );
  }
}

SolutionsList.displayName = 'SolutionsList';

SolutionsList.defaultProps = {
  fields: defaultData,
};

SolutionsList.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      Label: PropTypes.shape({ value: PropTypes.string }),
      RawValue: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  ),
  modalHeadline: PropTypes.string,
  currentQueryString: PropTypes.string,
};

export default SolutionsList;
